import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

import ModalSancion from "./Modal";
import Sancion from "./Sancion";
import SelectorCantidadSancion from "./SelectorCantidadSancion";

import "./Sancionaa.css";

const ObtieneSancionesAConfirmar = ({ refresca }) => {
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [
    listadoSanciones,
    setListadoSanciones,
  ] = useState([]);

  const [cargando, setCargando] = useState(false);

  const [
    sancionSeleccionada,
    setSancionSeleccionada,
  ] = useState(null);

  const [
    veoDatosSancion,
    setVeoDatosSancion,
  ] = useState(false);

  const [
    modificarValores,
    setModificarValores,
  ] = useState(false);

  const [error, setError] = useState("");

  // ============================================================
  // TOKEN
  // ============================================================

  const obtenerToken = () => {
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;

    return btoa(`${username}:${password}`);
  };

  // ============================================================
  // OBTENER SANCIONES A CONFIRMAR
  // ============================================================

const obtieneSancionesAConfirmar = useCallback(async () => {
  console.group("🟦 [SANCIONES] obtieneSancionesAConfirmar");

  console.log("👤 Usuario completo:", Usuario);

  console.table({
    id: Usuario?.id,
    nombre: Usuario?.nombre,
    apellido: Usuario?.apellido,
    sedeID: Usuario?.sedeID,
    funcion: Usuario?.funcion,
  });

  const esDirectorEP = comprueboPermisos(
    Usuario?.funcion,
    "Director EP"
  );

  const esSubdirectorEP = comprueboPermisos(
    Usuario?.funcion,
    "Subdirector EP"
  );

  console.log("🔐 PERMISOS DETECTADOS");
  console.log("¿Director EP?:", esDirectorEP);
  console.log("¿Subdirector EP?:", esSubdirectorEP);
  console.log(
    "¿Sede Provincial?:",
    Number(Usuario?.sedeID) === 1
  );

  if (!Usuario?.id) {
    console.warn(
      "⚠️ No existe Usuario.id. No se consultarán sanciones."
    );
    console.groupEnd();
    return;
  }

  try {
    setCargando(true);
    setError("");

    let sancionesTotales = [];

    // ======================================================
    // SEDE PROVINCIAL
    // ======================================================

    if (Number(Usuario?.sedeID) === 1) {
      console.log(
        "🏢 Usuario de SEDE PROVINCIAL → consultará ROSARIO + RECREO"
      );

      const url =
        "https://wwwa.isepsantafe.net.ar/expedientes/Ncadetes/devuelveSancionesAConfirmar";

      console.log("📡 Endpoint:", url);

      const [rosarioResponse, recreoResponse] =
        await Promise.all([
          axios.post(url, {
            sede: "Rosario",
          }),

          axios.post(url, {
            sede: "Recreo",
          }),
        ]);

      console.log(
        "📥 RESPUESTA COMPLETA ROSARIO:",
        rosarioResponse
      );

      console.log(
        "📥 DATA ROSARIO:",
        rosarioResponse?.data
      );

      console.log(
        "📥 RESPUESTA COMPLETA RECREO:",
        recreoResponse
      );

      console.log(
        "📥 DATA RECREO:",
        recreoResponse?.data
      );

      const sancionesRosario = Array.isArray(
        rosarioResponse?.data
      )
        ? rosarioResponse.data
        : [];

      const sancionesRecreo = Array.isArray(
        recreoResponse?.data
      )
        ? recreoResponse.data
        : [];

      console.log(
        `📊 Rosario devuelve ${sancionesRosario.length} sanciones`
      );

      console.log(
        `📊 Recreo devuelve ${sancionesRecreo.length} sanciones`
      );

      sancionesTotales = [
        ...sancionesRosario,
        ...sancionesRecreo,
      ];
    } else {
      // ====================================================
      // SEDE PARTICULAR
      // ====================================================

      console.log(
        "🏫 Usuario NO perteneciente a sede Provincial"
      );

      let sede = null;

      if (esSubdirectorEP) {
        sede =
          Number(Usuario?.sedeID) === 2
            ? "Rosario"
            : "Recreo";

        console.log(
          "✅ Es Subdirector EP. Se determina sede:",
          sede
        );
      } else {
        console.warn(
          "⚠️ NO es Subdirector EP. La variable sede queda NULL."
        );

        console.warn(
          "⚠️ Se realizará igualmente la consulta enviando:",
          {
            sede: null,
          }
        );
      }

      const url =
        "https://wwwa.isepsantafe.net.ar/expedientes/Ncadetes/devuelveSancionesAConfirmar";

      console.log("📡 Endpoint:", url);

      console.log("📤 BODY enviado:", {
        sede,
      });

      const response = await axios.post(url, {
        sede,
      });

      console.log(
        "📥 RESPUESTA COMPLETA:",
        response
      );

      console.log(
        "📥 DATA RECIBIDA:",
        response?.data
      );

      sancionesTotales = Array.isArray(
        response?.data
      )
        ? response.data
        : [];
    }

    // ======================================================
    // VER QUÉ LLEGÓ ANTES DEL FILTRO
    // ======================================================

    console.log(
      "📦 TOTAL DE SANCIONES ANTES DEL FILTRO:",
      sancionesTotales.length
    );

    console.log(
      "📦 SANCIONES CRUDAS:",
      sancionesTotales
    );

    if (sancionesTotales.length > 0) {
      console.table(
        sancionesTotales.map((s) => ({
          id: s?.id,
          cadeteDni: s?.cadeteDni,
          estado: s?.estado,
          cantidad: s?.cantidad,
          cadeteSede: s?.cadeteSede,
          idUsuarioSanciona:
            s?.idUsuarioSanciona,
          usuarioActual: Usuario?.id,
          esPropia:
            Number(s?.idUsuarioSanciona) ===
            Number(Usuario?.id),
        }))
      );
    }

    // ======================================================
    // DIRECTOR VE TODAS
    // RESTO NO CONFIRMA SUS PROPIAS SANCIONES
    // ======================================================

    let sancionesFiltradas = [];

    if (esDirectorEP) {
      console.log(
        "👑 CRITERIO: Es Director EP → VE TODAS LAS SANCIONES RECIBIDAS."
      );

      sancionesFiltradas = sancionesTotales;
    } else {
      console.log(
        "👮 CRITERIO: NO es Director EP → se eliminan las sanciones creadas por él mismo."
      );

      sancionesFiltradas = sancionesTotales.filter(
        (sancion) => {
          const usuarioSanciona = Number(
            sancion?.idUsuarioSanciona
          );

          const usuarioActual = Number(
            Usuario?.id
          );

          const puedeConfirmar =
            usuarioSanciona !== usuarioActual;

          console.log(
            `🔎 Sanción #${sancion?.id}`,
            {
              cadeteDni:
                sancion?.cadeteDni,

              estado:
                sancion?.estado,

              cantidad:
                sancion?.cantidad,

              idUsuarioSanciona:
                sancion?.idUsuarioSanciona,

              usuarioActual:
                Usuario?.id,

              puedeConfirmar,
              
              motivo: puedeConfirmar
                ? "✅ La sanción fue realizada por otro usuario"
                : "❌ La sanción fue realizada por el usuario actual",
            }
          );

          return puedeConfirmar;
        }
      );
    }

    // ======================================================
    // RESULTADO FINAL
    // ======================================================

    console.log(
      "✅ SANCIONES QUE FINALMENTE PODRÁ RESOLVER:",
      sancionesFiltradas.length
    );

    console.log(
      "✅ LISTADO FINAL:",
      sancionesFiltradas
    );

    if (sancionesFiltradas.length > 0) {
      console.table(
        sancionesFiltradas.map((s) => ({
          id: s?.id,
          dni: s?.cadeteDni,
          apellido:
            s?.cadete?.cadeteApellido,
          nombre:
            s?.cadete?.cadeteNombre,
          sede:
            s?.cadeteSede,
          estado:
            s?.estado,
          cantidad:
            s?.cantidad,
          idUsuarioSanciona:
            s?.idUsuarioSanciona,
        }))
      );
    }

    setListadoSanciones(
      sancionesFiltradas
    );
  } catch (error) {
    console.error(
      "❌ Error obteniendo sanciones a confirmar:",
      error
    );

    console.error(
      "❌ Response:",
      error?.response
    );

    console.error(
      "❌ Response data:",
      error?.response?.data
    );

    console.error(
      "❌ Status:",
      error?.response?.status
    );

    setListadoSanciones([]);

    setError(
      "No se pudieron obtener las sanciones pendientes de confirmación."
    );
  } finally {
    setCargando(false);

    console.log(
      "🏁 Finalizó obtieneSancionesAConfirmar"
    );

    console.groupEnd();
  }
}, [
  Usuario?.id,
  Usuario?.funcion,
  Usuario?.sedeID,
]);

  // ============================================================
  // CERRAR MODAL
  // ============================================================

  const cerrarModal = () => {
    setVeoDatosSancion(false);
    setSancionSeleccionada(null);
    setModificarValores(false);
  };

  // ============================================================
  // DEJAR SIN EFECTO
  // ============================================================

  const anulaSancion = async (sancion) => {
    try {
      const confirmacion = await Swal.fire({
        title: "¿Dejar sanción sin efecto?",
        text:
          "La sanción quedará anulada por resolución del superior.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "Sí, dejar sin efecto",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#b42318",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const datos = {
        idUsuarioControla: Usuario.id,

        usuarioControla:
          `${Usuario?.nombre || ""} ${
            Usuario?.apellido || ""
          }`.trim(),

        resuelveUsuarioControla:
          "Sin Efecto",

        cantidadConfirma: 0,

        fechaConfirma: new Date(),

        estado: "Anulada",
      };

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        datos,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title: "Sanción sin efecto",
          text: `La sanción del cadete DNI ${sancion.cadeteDni} fue dejada sin efecto.`,
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneSancionesAConfirmar();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo actualizar",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error dejando sanción sin efecto:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo dejar sin efecto la sanción.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  // ============================================================
  // CONFIRMAR
  // ============================================================

  const confirmarSancion = async (
    sancion
  ) => {
    try {
      const confirmacion = await Swal.fire({
        title: "Confirmar sanción",
        text: `Se confirmará la sanción de ${sancion?.cantidad} para el cadete DNI ${sancion?.cadeteDni}.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText:
          "Confirmar sanción",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#315f64",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const datos = {
        idUsuarioControla: Usuario.id,

        usuarioControla:
          `${Usuario?.nombre || ""} ${
            Usuario?.apellido || ""
          }`.trim(),

        resuelveUsuarioControla:
          "Confirmar",

        cantidadConfirma:
          sancion.cantidad,

        fechaConfirma: new Date(),

        estado: "Confirmada",
      };

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        datos,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title: "Sanción confirmada",
          text: `La sanción del cadete DNI ${sancion.cadeteDni} fue confirmada y continuará el circuito de notificación.`,
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneSancionesAConfirmar();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo confirmar",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error confirmando sanción:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo confirmar la sanción.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    obtieneSancionesAConfirmar();

    const handleActualizacion = () => {
      obtieneSancionesAConfirmar();
    };

    socket.on(
      "estadoActualizable",
      handleActualizacion
    );

    return () => {
      socket.off(
        "estadoActualizable",
        handleActualizacion
      );
    };
  }, [
    refresca,
    obtieneSancionesAConfirmar,
  ]);

  // ============================================================
  // CATEGORIAS
  // ============================================================

  const categorias = useMemo(() => {
    return listadoSanciones.reduce(
      (acc, sancion) => {
        const estado =
          sancion?.estado ||
          "Sin estado";

        if (!acc[estado]) {
          acc[estado] = [];
        }

        acc[estado].push(sancion);

        return acc;
      },
      {}
    );
  }, [listadoSanciones]);

  // ============================================================
  // ABRIR SANCION
  // ============================================================

  const manejoQueVeo = (sancion) => {
    setSancionSeleccionada(sancion);

    setModificarValores(false);

    setVeoDatosSancion(true);
  };

  // ============================================================
  // HELPERS
  // ============================================================

  const nombreCompleto = (sancion) => {
    const apellido =
      sancion?.cadete
        ?.cadeteApellido || "";

    const nombre =
      sancion?.cadete
        ?.cadeteNombre || "";

    return `${apellido} ${nombre}`.trim();
  };

  const obtenerUbicacion = (
    sancion
  ) => {
    const compania =
      sancion?.cadete?.Seccion
        ?.Compania?.nombre;

    const seccion =
      sancion?.cadete?.Seccion
        ?.nombre;

    return [compania, seccion]
      .filter(Boolean)
      .join(" · ");
  };

  const obtenerPromocion = (
    sancion
  ) => {
    return (
      sancion?.cadete
        ?.Promocions?.[0]
        ?.nombre || null
    );
  };

  const formatearFecha = (fecha) => {
    if (!fecha) {
      return "-";
    }

    const partes =
      String(fecha).split("-");

    if (partes.length === 3) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return fecha;
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* MODAL RESOLVER */}
      {/* ====================================================== */}

      {veoDatosSancion &&
        sancionSeleccionada && (
          <ModalSancion
            isOpen={
              veoDatosSancion
            }
            onClose={cerrarModal}
          >
            <div className="san-v2-modal">

              {/* ============================================ */}
              {/* HEADER */}
              {/* ============================================ */}

              <div className="san-v2-modal-header">

                <span className="san-v2-modal-eyebrow">
                  CONTROL DISCIPLINARIO
                </span>

                <h3>
                  Resolver sanción
                </h3>

                <p>
                  Revise la actuación disciplinaria
                  y determine la resolución
                  correspondiente.
                </p>

              </div>

              {/* ============================================ */}
              {/* CADETE */}
              {/* ============================================ */}

              <div className="san-v2-selected-person">

                <div className="san-v2-avatar">
                  {sancionSeleccionada
                    ?.cadete
                    ?.cadeteApellido
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    "C"}
                </div>

                <div className="san-v2-selected-info">

                  <span>
                    CADETE
                  </span>

                  <strong>
                    {nombreCompleto(
                      sancionSeleccionada
                    ) ||
                      `DNI ${sancionSeleccionada.cadeteDni}`}
                  </strong>

                  <small>
                    DNI{" "}
                    {
                      sancionSeleccionada.cadeteDni
                    }
                    {" · "}
                    Sanción:{" "}
                    {sancionSeleccionada
                      ?.cantidad ||
                      "-"}
                  </small>

                </div>

                <span className="san-v2-section-badge san-v2-badge-warning">
                  A confirmar
                </span>

              </div>

              {/* ============================================ */}
              {/* DETALLE */}
              {/* ============================================ */}

              <div className="san-v2-form-container">

                <Sancion
                  sancionPasada={
                    sancionSeleccionada
                  }
                />

                {/* ========================================== */}
                {/* MODIFICAR CANTIDAD */}
                {/* ========================================== */}

                <div
                  style={{
                    marginTop: "16px",
                    paddingTop: "16px",
                    borderTop:
                      "1px solid #eaecf0",
                  }}
                >

                  <button
                    type="button"
                    className="san-v2-btn-secondary"
                    onClick={() =>
                      setModificarValores(
                        (prev) => !prev
                      )
                    }
                  >
                    {modificarValores
                      ? "Cancelar modificación"
                      : "Aumentar o disminuir sanción"}
                  </button>

                  {modificarValores && (
                    <div
                      style={{
                        marginTop: "14px",
                        padding: "14px",
                        border:
                          "1px solid #e4e7ec",
                        borderRadius:
                          "12px",
                        background:
                          "#f9fafb",
                      }}
                    >
                      <SelectorCantidadSancion
                        sancion={
                          sancionSeleccionada
                        }
                        valores={() => {
                          cerrarModal();

                          obtieneSancionesAConfirmar();
                        }}
                      />
                    </div>
                  )}

                </div>

                {/* ========================================== */}
                {/* ACCIONES */}
                {/* ========================================== */}

                <div
                  style={{
                    display: "flex",
                    justifyContent:
                      "flex-end",
                    gap: "9px",
                    flexWrap: "wrap",
                    marginTop: "18px",
                    paddingTop: "15px",
                    borderTop:
                      "1px solid #eaecf0",
                  }}
                >

                  <button
                    type="button"
                    className="san-v2-btn-secondary"
                    disabled={
                      modificarValores
                    }
                    onClick={() =>
                      anulaSancion(
                        sancionSeleccionada
                      )
                    }
                    style={{
                      color:
                        "#b42318",
                    }}
                  >
                    Sin efecto
                  </button>

                  <button
                    type="button"
                    className="san-v2-btn-primary"
                    disabled={
                      modificarValores
                    }
                    onClick={() =>
                      confirmarSancion(
                        sancionSeleccionada
                      )
                    }
                  >
                    ✓ Confirmar sanción
                  </button>

                </div>

              </div>

            </div>
          </ModalSancion>
        )}

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <div style={{ width: "100%" }}>

        {/* ==================================================== */}
        {/* RESUMEN */}
        {/* ==================================================== */}

        <div className="san-v2-summary">

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon san-v2-stat-icon-confirm">
              ✓
            </div>

            <div>

              <span>
                Pendientes de control
              </span>

              <strong>
                {cargando
                  ? "..."
                  : listadoSanciones.length}
              </strong>

              <small>
                Sanciones a resolver
              </small>

            </div>

          </div>

        </div>

        {/* ==================================================== */}
        {/* ERROR */}
        {/* ==================================================== */}

        {error && (
          <section
            className="san-v2-section"
            style={{
              borderColor:
                "#fecdca",
            }}
          >
            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "14px",
                color:
                  "#b42318",
              }}
            >
              {error}
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* CARGANDO */}
        {/* ==================================================== */}

        {cargando && (
          <section className="san-v2-section">
            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "30px",
                textAlign:
                  "center",
                color:
                  "#667085",
              }}
            >
              Obteniendo sanciones pendientes
              de confirmación...
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* VACIO */}
        {/* ==================================================== */}

        {!cargando &&
          listadoSanciones.length ===
            0 && (
            <section className="san-v2-section">

              <div
                className="san-v2-section-content"
                style={{
                  padding:
                    "35px 20px",
                  textAlign:
                    "center",
                }}
              >

                <div
                  className="san-v2-stat-icon san-v2-stat-icon-confirm"
                  style={{
                    margin:
                      "0 auto 10px",
                  }}
                >
                  ✓
                </div>

                <strong
                  style={{
                    display:
                      "block",
                    color:
                      "#344054",
                    fontSize:
                      "13px",
                  }}
                >
                  No hay sanciones para confirmar
                </strong>

                <span
                  style={{
                    display:
                      "block",
                    marginTop:
                      "4px",
                    color:
                      "#98a2b3",
                    fontSize:
                      "11px",
                  }}
                >
                  No existen actuaciones pendientes
                  de resolución.
                </span>

              </div>

            </section>
          )}

        {/* ==================================================== */}
        {/* LISTADOS */}
        {/* ==================================================== */}

        {!cargando &&
          Object.entries(categorias).map(
            ([
              estado,
              sanciones,
            ]) => (
              <section
                key={estado}
                className="san-v2-section"
              >

                {/* ========================================== */}
                {/* HEADER */}
                {/* ========================================== */}

                <div className="san-v2-section-header">

                  <div className="san-v2-section-title-group">

                    <div className="san-v2-indicator san-v2-indicator-warning" />

                    <div>
                      <h2>
                        {estado}
                      </h2>

                      <p>
                        {
                          sanciones.length
                        }{" "}
                        {sanciones.length ===
                        1
                          ? "sanción pendiente"
                          : "sanciones pendientes"}{" "}
                        de resolución.
                      </p>
                    </div>

                  </div>

                  <span className="san-v2-section-badge san-v2-badge-warning">
                    {
                      sanciones.length
                    }
                  </span>

                </div>

                {/* ========================================== */}
                {/* REGISTROS */}
                {/* ========================================== */}

                <div className="san-v2-section-content">

                  {sanciones.map(
                    (
                      sancion,
                      index
                    ) => {
                      const ubicacion =
                        obtenerUbicacion(
                          sancion
                        );

                      const promocion =
                        obtenerPromocion(
                          sancion
                        );

                      return (
                        <div
                          key={
                            sancion?.id ||
                            index
                          }
                          className="san-v2-selected-person"
                          style={{
                            margin:
                              "6px",
                            background:
                              "#ffffff",
                          }}
                        >

                          {/* ================================== */}
                          {/* NUMERO */}
                          {/* ================================== */}

                          <div className="san-v2-avatar">
                            {index + 1}
                          </div>

                          {/* ================================== */}
                          {/* INFO */}
                          {/* ================================== */}

                          <div className="san-v2-selected-info">

                            <span>
                              SANCIÓN #
                              {sancion?.id ||
                                "-"}
                            </span>

                            <strong>
                              {nombreCompleto(
                                sancion
                              ) ||
                                `DNI ${sancion?.cadeteDni}`}
                            </strong>

                            <small>
                              DNI{" "}
                              {
                                sancion?.cadeteDni
                              }

                              {" · "}

                              Fecha:{" "}
                              {formatearFecha(
                                sancion?.fechaFaltaCometida
                              )}

                              {sancion?.cadeteSede
                                ? ` · Sede: ${sancion.cadeteSede}`
                                : ""}

                              {ubicacion
                                ? ` · ${ubicacion}`
                                : ""}

                              {promocion
                                ? ` · Promoción: ${promocion}`
                                : ""}

                              {sancion?.cantidad
                                ? ` · Cantidad: ${sancion.cantidad}`
                                : ""}
                            </small>

                          </div>

                          {/* ================================== */}
                          {/* RESOLVER */}
                          {/* ================================== */}

                          <button
                            type="button"
                            className="san-v2-btn-primary"
                            onClick={() =>
                              manejoQueVeo(
                                sancion
                              )
                            }
                          >
                            Resolver
                          </button>

                        </div>
                      );
                    }
                  )}

                </div>

              </section>
            )
          )}
      </div>
    </>
  );
};

export default ObtieneSancionesAConfirmar;